import React, { useState } from 'react';
import Modal from 'react-modal';
import './css/AddBenefitBuildingModal.css';

const AddBenefitBuildingModal = ({ isOpen, onRequestClose, onAddBenefitBuilding }) => {
  const [benefitSubType, setbenefitSubType] = useState('lab'); // Default to 'lab'

  const handleAdd = () => {
    onAddBenefitBuilding({ benefitSubType });
    onRequestClose();
  };

  const modalStyle = {
    content: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%', // Use 90% width for smaller screens
      maxWidth: '400px', // Limit max width for larger screens
      height: 'auto',
      maxHeight: '80vh', // Prevent overflow
      overflowY: 'auto', // Enable scrolling if needed
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
  };
  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Add Benefit Building"
      className="add-benefit-building-modal"
      overlayClassName="add-benefit-building-modal-overlay"
      style={modalStyle}
    >
      <h2>Add Benefit Building</h2>
      <label>
        Select Sub-Type:
        <select value={benefitSubType} onChange={(e) => setbenefitSubType(e.target.value)}>
          <option value="lab">Lab</option>
          <option value="militaryArea">Military Area</option>
          <option value="mechanicShop">Mechanic Shop</option>
          <option value="warFactory">War Factory</option>
        </select>
      </label>
      <button onClick={handleAdd}>Add Benefit Building</button>
      <button onClick={onRequestClose}>Cancel</button>
    </Modal>
  );
};

export default AddBenefitBuildingModal;
